import ApiService from "@/common/api.service"

export const UserService = {
    create(params) {
        return ApiService.post("user/registerUser", params);
    },
    update(slug, params) {
        return ApiService.update("/user", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("user/registerUser/delete", slug, params)
    },
    async getUsers() {
        const res = await ApiService.get("user/getUsers");
        return res.data;
    },
    async getUsersWP(page, itemsPerPage, name) {
        const res = await ApiService.get(
            `/user/getUsers?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return res.data;
    }

}